import styled from 'styled-components';
import { gridClasses } from '@mui/x-data-grid-premium';

export const TableContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  .${gridClasses.root} {
    .${gridClasses.pivotPanelField} {
      padding-left: 20px !important;
    }

    .${gridClasses.pivotPanelFieldCheckbox} {
      margin-bottom: 0 !important;
    }
  }
`;
